<template>
  <MilestoneDetails
    :milestone="getMileStones(project_id).find(milestone => milestone.milestone.id === milestone_id)"
    >
    <template #header="{milestone}">
      <MileStone
        class="ml-4 mt-7"
        :large="true"
        :status="getTrainMilestoneStatus({milestone_id: milestone.milestone.id, project_id})"
        type="train"
        >
        <StandardDataField
          :value="milestone.milestone.token"
          width="100%"
          flat="true"
          text_center="true"
          :maxlength="2"
          readonly="true"
          text_color="white"
          />
      </MileStone>
      <StandardDataField
        class="ml-10"
        :value="milestone.milestone.name"
        :text_color="$vuetify.theme.isDark ? 'white' : 'black'"
        width="80%"
        :flat="true"
        readonly="true"
        />
    </template>
    <template #body="{milestone}">
      <v-divider class="mb-1"/>
      <StandardFlexBox id="flexboxtest">
        <v-spacer/>
        <StandardDataField
          :value="milestone.milestone.offset"
          :text_color="$vuetify.theme.isDark ? 'white' : 'black'"
          width="15%"
          :flat="true"
          :readonly="true"
          type="number"
          />
        <div class="ml-1 user-select-none">TT</div>
        <v-spacer/>
        <StandardDataField
          :value="milestone.milestone.chronology"
          :text_color="$vuetify.theme.isDark ? 'white' : 'black'"
          width="50%"
          flat="true"
          readonly="true"
          />
      </StandardFlexBox>
      <v-divider class="mt-1 mb-1"/>
      <template v-if="milestone.milestone.linkType !== 'type'">
        <div>{{$t('Project.Milestones.Train.Selection')}}:</div>
        <div class="mt-1" style="font-size: 12px">
          {{milestone.milestone.trains.length}} {{$t('Project.Milestones.Train.TrainS[0]')}}{{milestone.milestone.trains.length === 1?'':$t('Project.Milestones.Train.TrainS[1]')}},
          {{milestone.milestone.taktareas.length}} {{$t('Project.Milestones.Train.TaktareaS[0]')}}{{milestone.milestone.taktareas.length === 1?'':$t('Project.Milestones.Train.TaktareaS[0]')}},
          {{milestone.milestone.work_packages.length}} {{$t('Project.Milestones.Train.WorkpackageS[0]')}}{{milestone.milestone.work_packages.length === 1?'':$t('Project.Milestones.Train.WorkpackageS[0]')}}
        </div>
        <div class="mb-2" style="font-size: 12px">
          {{$t('Project.Milestones.Train.CalculatedDate')}}: {{milestone.calculated_date?milestone.calculated_date.toISOString().substring(0,10):''}}
        </div>
        <StandardFlexBox
          direction="column"
          height="85%"
          :no_wrap="true"
          gap="12px"
          >
        <div
          v-for="train in milestone.selection"
          :key="train.id"
          :style="train.selected?'color: white':'color: #757575'"
          >
          <v-divider/>
          <v-icon v-if="train.selected" size="16">check_circle</v-icon>
          {{getTrain(train.id).name}}
          <div v-if="milestone.decisive_entity.type == 'train' && milestone.decisive_entity.id == train.id" class="milestone-icon"/>
          <div
            class="ml-3"
            v-for="taktarea in train.taktareas"
            :key="taktarea.id"
            :style="taktarea.selected?'color: white':'color: #757575'"
            >
            <v-icon v-if="taktarea.selected" size="16">check_circle</v-icon>
            {{getTaktarea(taktarea.id).name}}
            <div v-if="milestone.decisive_entity.type == 'taktarea' && milestone.decisive_entity.id == taktarea.id" class="milestone-icon"/>
            <StandardFlexBox
            class="ml-3"
            >
              <WorkPackage
                v-for="work_package in taktarea.work_packages"
                :key="work_package.id"
                class="ml-1 mb-1 mt-1"
                :workpackage="getTWorkPackage(work_package.id)"
                :style="(milestone.decisive_entity.type == 'work_package' && milestone.decisive_entity.id == work_package.id)?'border-style: solid; border-width: 1px !important; border-color: white !important; border-radius: 5px;':''"
                :zoom="0.75"
                @click.native="openWaggonInfo(train.id, taktarea.id, work_package.waggon_id, work_package.id, $event)"
              >
              <!-- @click.native="openWaggonInfo(train.id, taktarea.id, work_package.waggon_id, work_package.id, $event)" -->
                <template #workpackage="workpackageslot">
                  <StandardBadge
                    :zoom="0.7"
                    class=""
                    v-if="
                          workpackageslot.workpackage.status &&
                          (workpackageslot.workpackage.status !== 'none' || workpackageslot.workpackage.stop_status !== 'none') &&
                          workpackageslot.workpackage.status !== 'stop'
                          "
                    :key="`workpackagebadge${work_package.id}`"
                    :icon="findIcon(workpackageslot)"
                    color="white"
                    :content_color="workpackageslot.workpackage.stop_status !== 'none' ? 'red':'black'"
                    @click.native="openWaggonInfo(train.id, taktarea.id, work_package.waggon_id, work_package.id, $event)"
                  />
                  <!-- @click.native="openWaggonInfo(train.id, taktarea.id, work_package.waggon_id, work_package.id, $event)" -->
                </template>
              </WorkPackage>
            </StandardFlexBox>
          </div>
        </div>
        </StandardFlexBox>
      </template>
      <template v-else>
        {{$t('Project.Milestones.Train.Type')}}:
        <div class="mb-2 mt-1" style="font-size: 12px">
          {{$t('Project.Milestones.Train.CalculatedDate')}}: {{milestone.calculated_date?milestone.calculated_date.toISOString().substring(0,10):''}}
        </div>
        <StandardFlexBox v-if="milestone.milestone.wp_color_active" class="mt-3 ml-1" height="35px">
          <v-icon size="24">check_box</v-icon>
          <div class="ml-1">{{$t('Project.Milestones.Train.Color')}}:</div>
          <div class="white ml-2" style="width: 34px; height: 24px; border-radius: 3px; padding: 3px">
            <div :class="`${milestone.milestone.wp_color} ${milestone.milestone.wp_color.includes('lighten') || milestone.milestone.wp_color.includes('darken')? '':'lighten-1'}`" style="width: 100%; height: 100%; border-radius: 3px"/>
          </div>
        </StandardFlexBox>
        <StandardFlexBox v-if="milestone.milestone.wp_token_active" class="mt-3 ml-1" height="35px">
          <v-icon size="24">check_box</v-icon>
          <div class="ml-1">{{$t('Project.Milestones.Train.Token')}}:</div>
          <div class="ml-2">{{milestone.milestone.wp_token}}</div>
        </StandardFlexBox>
        <StandardFlexBox v-if="milestone.milestone.wp_icon_active" class="mt-3 ml-1" height="35px">
          <v-icon size="24">check_box</v-icon>
          <div class="ml-1">{{$t('Project.Milestones.Train.Icon')}}:</div>
          <div class="white ml-2" style="display: flex; justify-content: center; align-items: center; width: 34px; height: 24px; border-radius: 3px;">
            <v-icon
              class="icon"
              v-if="isStandardIcon(milestone.milestone.wp_icon)"
              color="black"
              >
              {{milestone.milestone.wp_icon}}
            </v-icon>
            <svg-icon
              v-else
              class="svg-icon"
              :name="milestone.milestone.wp_icon"
              :size="20"
              style="height: 20px"
            />
          </div>
        </StandardFlexBox>
        <StandardFlexBox v-if="milestone.milestone.wp_name_active" class="mt-3 ml-1" height="35px">
          <v-icon size="24">check_box</v-icon>
          <div class="ml-1">{{$t('Project.Milestones.Train.Name')}}:</div>
          <div class="ml-2">{{milestone.milestone.wp_name}}</div>
        </StandardFlexBox>
      </template>
    </template>
  </MilestoneDetails>
</template>
<script>
  import { MilestonesMixin } from '@/mixins/Milestones.mixin.js'
  export default {
    props: ['project_id', 'milestone_id'],
    components:{
    },
    mixins: [
      MilestonesMixin
    ],
    methods: {
      openWaggonInfo(train_id, taktarea_id, waggon_id, tworkpackage_id, evt) {
        // let x =  -window.innerWidth/2 + evt.clientX;
        // let y = -window.innerHeight/2 + evt.clientY;
        // document.body.style.setProperty('--waggon_offset_x', `${x}px`);
        // document.body.style.setProperty('--waggon_offset_y', `${y}px`);
        if (tworkpackage_id == 'linter ist kacke') {
          console.log(evt);
        }

        let params = {
          project_id: this.project_id,
          train_id: train_id,
          taktarea_id: taktarea_id,
          twaggon_id: waggon_id,
          tworkpackage_id: tworkpackage_id,
        };
        // console.log(params, evt);
        this.$router.push({
          name: 'TaktPlanWorkPackageInfo',
          params: params,
          });
      },
      findIcon(workpackageslot) {
        if (workpackageslot.workpackage.stop_status !== 'none') {
          if (workpackageslot.workpackage.stop_status === 'ai_stop') {
            return 'ai_stop'
          }
          else {
            return 'warning'
          }
        }
        else {
          // console.log(this.getStatusArray.find(status => status.name === workpackageslot.workpackage.status));
          return this.getStatusArray.find(status => status.name === workpackageslot.workpackage.status).icon
        }
      }
    }
  }
</script>
<style scoped>
  .milestone-icon {
    margin-top: 3px;
    margin-left: 5px;
    width: 12px;
    height: 12px;
    border-radius: 2px;
    transform: rotate(45deg);
    cursor: pointer;
    background-color: white;
    background-color: var(--v-primary-base);
    display: inline-block;
  }
</style>
